export const o_xy = (data: any) => {
  const points: any = []
  data.forEach((item: any) => {
    const x = item.x1
    const y = item.y1
    points.push([x, y])
  })
  return {
    title: {
      text: "x-y图",
      left: "center",
      top: "10px",
      textStyle: {
        fontSize: 20,
        fontWeight: "bold",
        color: "#000",
      },
    },
    grid: {
      left: 100
    },
    tooltip: {
      trigger: "item",
      formatter: function (params) {
        return `${params.seriesName}<br/>${params.marker}${params.name}: ${params.value[1]}%`;
      },
    },
    xAxis: {
      type: "value",
      name: "液相",
      nameLocation: "middle",
      nameGap: 30,
      nameTextStyle: {
        fontSize: 14,
        // fontWeight: "bold",
        color: "#000",
      },
      // min: 0,
      // max: 1,
    },
    yAxis: {
      type: "value",
      name: "气相",
      nameLocation: "middle",
      nameGap: 30,
      nameTextStyle: {
        fontSize: 14,
        // fontWeight: "bold",
        color: "#000",
      },
      // min: 0,

    },
    series: [
      {
        name: "",
        type: "line",
        // symbolSize: 10,
        // markLine: {
        //   data: [
        //     {
        //         name: '两个坐标之间的标线',
        //         coord: [0, 0]
        //     },
        //     {
        //       coord: [1, 1]
        //     },
        //   ]
        // },
        data: points
      },
      {
        name: "",
        type: "line",
        symbolSize: 0,
        lineStyle: {
          type: 'dashed',
          color: 'rgba(0,0,0,0.3)',
        },
        // markLine: {
        //   data: [
        //     {
        //         name: '两个坐标之间的标线',
        //         coord: [0, 0]
        //     },
        //     {
        //       coord: [1, 1]
        //     },
        //   ]
        // },
        data: [[0, 0], [1, 1]]
      },
    ],
  };
}

export const o_p_xy = (data: any, max: any = null) => {
  const P_bub: any = []//泡点压力
  const P_dew: any = []//露点压力
  const P_bubs: any = []//露点集合
  const P_dews: any = []//泡点集合
  data.forEach((item: any) => {
    P_bubs.push(item.P_bub)
    P_dews.push(item.P_dew)
    P_bub.push([item.z1, item.P_bub])
    P_dew.push([item.z1, item.P_dew])
  })

  const P_bubsmax = Math.max(...P_bubs)
  // const P_dewsmax=Math.max(...P_dews)
  let P_bubArea: any = [];//液相区
  const P_dewArea: any = [[0, 0], ...P_dew, [1, 0], [0, 0]];//气相区
  // const qy_area:any=[];//气液两相区

  P_bub.map((item: any) => {
    P_bubArea.push([item[0], max !== null ? max : P_bubsmax])
  })
  P_bubArea.push(...P_bub.reverse(), [0, max !== null ? max : P_bubsmax]);
  // P_dew.map((item:any)=>{
  //   P_dewArea.push([item[0],0])
  // })
  // P_dewArea.push(P_dew[0]);
  // P_dewArea.push([0,0]);


  return {
    title: {
      text: "P-x-y图",
      left: "center",
      top: 0,
      textStyle: {
        fontSize: 20,
        fontWeight: "bold",
        color: "#000",
      },
    },
    grid: {
      left: 100,
      right:110
    },
    tooltip: {
      trigger: "item",
      formatter: (params: any) => {
        return `${params.marker}压力: ${params.value[1]} Pa`;
      },
    },
    // legend:{
    //   top:30
    // },

    legend: {
      itemWidth: 14,
      itemHeight: 14,
      orient:'vertical',
      top: 50,
      right: 5,
      data: [
        {
          name: "泡点线",
          icon: 'circle',
          itemStyle: {
            color: "red",
          },
        },
        {
          name: "露点线",
          icon: 'circle',
          itemStyle: {
            color: "blue",
          },

        },
        {
          name: "气相区",
          icon: "rect",

          itemStyle: {
            color: "rgba(255, 176, 49, 0.2)",
            borderType: "dashed",
            borderWidth: 1,
            borderColor: "rgb(255, 176, 49)",
          },
        },
        {
          name: "液相区",
          icon: "rect",

          itemStyle: {
            color: "rgba(103, 24, 249, 0.1)",
            borderType: "dashed",
            borderWidth: 1,
            borderColor: "rgba(103, 24, 249, 0.5)",
          },
        },
        {
          name: "气液两相区",
          icon: "rect",

          itemStyle: {
            color: "rgba(0, 232, 149, 0.3)",
            borderType: "dashed",
            borderWidth: 1,
            borderColor: "rgba(0, 77, 49, 0.3)",
          },
        },
      ],
    },
    xAxis: {
      type: "value",
      name: "汽相摩尔分率",
      nameLocation: "middle",
      nameGap: 30,
      nameTextStyle: {
        fontSize: 14,
        // fontWeight: "bold",
        color: "#000",
      },
    },
    yAxis: {
      type: "value",
      name: "压力 (Pa)",
      // nameLocation: "middle",
      // nameGap: 302
      nameTextStyle: {
        fontSize: 14,
        // fontWeight: "bold",
        color: "#000",
      },
      // max: Math.max(...[...P_bubs,...P_dews]),
    },


    series: [

      {
        name: "气相区",
        type: "line",
        symbolSize: 0,
        data: P_dewArea,
        lineStyle: {
          color: "rgb(255, 176, 49)",
          type: 'dotted',
          width: 3
        },
        areaStyle: {
          color: "rgba(255, 176, 49, 0.2)",
        }
      },
      {
        name: "液相区",
        type: "line",
        symbolSize: 0,
        data: P_bubArea,
        lineStyle: {
          color: "rgba(103, 24, 249, 0.5)",
          type: 'dotted',
          width: 3
        },
        areaStyle: {
          color: "rgba(103, 24, 249, 0.1)",
        }
      },
      {
        name: "气液两相区",
        type: "line",
        lineStyle: {
          color: "rgba(45, 60, 57,0)",
          // type: 'dashed',
        },
        symbolSize: 0,
        data: [...P_bub, ...P_dew],
        areaStyle: {
          color: "rgba(0, 232, 149, 0.3)",
        }
      },
      {
        name: "泡点线",
        type: "line",
        symbolSize: 0,
        symbol: "circle",
        lineStyle: {
          color: "red",
          // type: 'dotted',
          width: 3
        },
        data: P_bub
      },
      {
        name: "露点线",
        type: "line",
        symbolSize: 0,
        symbol: "circle",
        lineStyle: {
          color: "blue",
          // type: 'dotted',
          width: 3
        },
        data: P_dew
      },
    ],
  };
}